import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { Link, useParams } from 'react-router-dom';

import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const trackShare = async (type, value) => {
  const { response: user } = (await StorageHandler.load(storageKeys.user)) || {};
  let val = value;
  if (!value) {
    val = type.type;
  }
  if (val === 'weblink') {
    val = type.url;
  }
  if (user) {
    APIHandler.trackEvent(DataHandler.matchAppIdSync(), user.email, 'collateral', type.type, val);
  }
};

const parseProps = ({ params: { type: pageType }, url, type, id }) => {
  const props = {};

  const expressions = {
    libraries: /^(image|video)_library$/g,
    carousel: /^carousel$/g,
    web: /^web(link)?$/g,
    fancybox: /^(iframe|image|infographic|pdf)/g,
    contact: /^(contact_us)$/g,
    hash: /^(multi)$/g,
    internal: /^(retain|training)/g,
    other: /^.*?$/g, // This type should match the default case only
  };

  const [match] = Object.keys(expressions).filter((key) => type.match(expressions[key]));

  const fancyBoxProps = {
    'data-src': url,
    'data-fancybox': id,
    'data-fancybox-trigger': id,
    ...(type === 'iframe' && { 'data-type': type }),
  };

  switch (match) {
    case 'web':
      Object.assign(props, {
        target: '_blank',
        rel: 'noreferrer noopener',
        href: url,
      });
      break;

    case 'carousel':
      props.to = [pageType, url];
      break;

    case 'contact':
      props.to = ['services', 'contact'];
      break;

    case 'libraries':
      props.to = [pageType, `${(type.match(/^(image|video)/g) || [])[0]}s`];
      break;

    case 'fancybox':
      Object.assign(props, { ...fancyBoxProps });
      break;

    case 'hash':
      Object.assign(props, { ...fancyBoxProps, 'data-src': `#${id}` });
      break;

    case 'internal':
      props.to = url;
      break;

    default:
      props.to = [type];
      break;
  }

  if (props.to !== undefined && props.to !== url) props.to = ['/main', ...props.to].join('/').replace(/\/\//g, '/');

  return props;
};

const LinkHandler = ({ className, children, url, ...props }) => {
  const params = useParams();

  let Element = 'div';
  if (typeof url === 'string' && url) {
    Element = url.startsWith('http') ? 'a' : Link;
  }

  const parsedProps = parseProps({ params, url, ...props });

  return (
    <Element className={clsx(className)} onClick={() => trackShare(props)} {...parsedProps}>
      {children}
    </Element>
  );
};

LinkHandler.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};

LinkHandler.defaultProps = {
  url: '',
  className: null,
};

export default LinkHandler;